module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-one.d630f794.png";